/**
 * Anzeigedauer für Meldungen, die ohne Bestätigung wieder verschwinden (Toasts, Fehler,
 * Inline-Hinweise). Einzige Quelle — neue Meldungen ohne OK-Button müssen diese Funktion nutzen.
 *
 * Dauer richtet sich nach der Textlänge (Lesezeit), mit Untergrenze und Obergrenze.
 * Fehler bleiben länger stehen: man muss sie verstehen, um zu reagieren.
 */

/** Sockel für jede Meldung (Blick hinwenden, Meldung erfassen). */
export const NOTICE_BASE_MS = 3_000;

/** Lesezeit je Zeichen — bewusst großzügig (~14 Zeichen/s, Mobile + Deutsch). */
export const NOTICE_MS_PER_CHAR = 70;

/** Untergrenze für normale Meldungen (vorher 3 s). */
export const NOTICE_MIN_MS = 6_000;

/** Untergrenze für Fehlermeldungen. */
export const NOTICE_ERROR_MIN_MS = 9_000;

/** Obergrenze, damit lange Texte nicht ewig stehen bleiben. */
export const NOTICE_MAX_MS = 20_000;

/** Dauer des Ausblendens am Ende (muss zur CSS-Transition passen). */
export const NOTICE_FADE_MS = 400;

export function calcNoticeDisplayMs(text: string, isError = false): number {
  const reading = NOTICE_BASE_MS + text.trim().length * NOTICE_MS_PER_CHAR;
  const min = isError ? NOTICE_ERROR_MIN_MS : NOTICE_MIN_MS;
  return Math.min(NOTICE_MAX_MS, Math.max(min, reading));
}
